/* Add-to-basket straight from a product card, used on the All Dining Tables
   and All Dining Seating collection pages.

   Loaded ONCE from layout/theme.liquid - NEVER from the card snippet, which
   renders once per card. When this file was included there, every card on
   the page executed its own copy and one click fired one /cart/add.js per
   card: the first add succeeded, the rest came back 422 ("you can only add
   1"), which tripped the error fallback and bounced the shopper to /cart.
   The idempotency guard below stays as a backstop so an accidental second
   include can never re-attach the listener.

   Delegated submit handler, so it also covers cards rendered after load
   (pagination, filtering). Adds via /cart/add.js and asks Shopify for the
   cart-drawer section in the same round trip, so the drawer re-renders
   without a page reload. */
(function () {
  if (window.__jjCardAtcReady) return;
  window.__jjCardAtcReady = true;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('.jj-card-atc__form');
    if (!form) return;

    event.preventDefault();

    /* A second click while the first is still in flight would hit the same
       422, so the form is locked for the duration. */
    if (form.dataset.jjBusy === '1') return;
    form.dataset.jjBusy = '1';

    var button = form.querySelector('.jj-card-atc__btn');
    var idField = form.querySelector('input[name="id"]');
    if (!idField) {
      form.dataset.jjBusy = '';
      return;
    }

    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    function restore() {
      form.dataset.jjBusy = '';
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: idField.value, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) {
          /* Already in the basket, or out of stock. Say so on the button
             rather than navigating away and losing their place. */
          if (button) {
            button.textContent = 'Already in basket';
            setTimeout(restore, 2000);
          }
          form.dataset.jjBusy = '';
          return;
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && result.data.sections) {
          drawer.renderContents(result.data);
          restore();
          return;
        }

        window.location.reload();
      })
      .catch(function () {
        restore();
        window.location.href = '/cart';
      });
  });
})();